import React from "react";

import ReactMarkdown from "react-markdown";
import MarkdownHelper from '../../utils/MarkdownHelper';

import { Button } from 'react-bootstrap';

import IconInfo from './../../../assets/icons/icon_std_info_circle.svg';
import IconClock from './../../../assets/icons/ico100_clock.svg'
import IconPhone from './../../../assets/icons/icon_std_cellphone.svg';
import {default as t} from '../../utils/Translate';

const PhotoCreditOverlay = props => (

    <div className="app-type app-spacers">
        <div className="app-view mb-md">
            <div className="photo-credit-overlay-container">
                <div className="photo-credit-overlay-content">
                    <div className="modal-terms-and-conditions">
                        <div className="photo-credit-terms-modal--title">
                            {t(`What's valid for my promotion`, props.lang)}
                        </div>
                        <div className="photo-credit-terms-modal--subtitle"> {t('General note', props.lang)}</div>
                        <div className="photo-credit-terms-modal--content">
                        {t('Only uploads that are part of a current photo-credit can be dealt with. The uploading of boarding passes is exempted from this.', props.lang)}
                        </div>
                        <div className="photo-credit-terms-modal--subtitle2">
                        {t('Current promotions and Terms & Conditions', props.lang)}
                        </div>
                        <div className="photo-credit-image-container">
                            <img src={props.campaign.image_3_2} alt="overlay_image" className="photo-credit-image" />
                        </div>
                        <div className="photo-credit-terms-modal--brand-name">{props.campaign.title_caption}</div>
                        <div className="photo-credit-terms-modal--copy-long">
                            <ReactMarkdown {...MarkdownHelper.allTypes()}
                                        source={props.campaign.copy_long}
                                        escapeHtml={false}  />
                        </div>
                        <div className="photo-credit-terms-modal--points">
                            <div className="icn">
                                <img src={IconClock} alt="Clock" className="photo-credit-icons" />
                            </div>
                            <div className="photo-credit-container__content-point-data">
                                <div className="photo-credit-container__content-point-title laufzeit">
                                {t('Duration', props.lang)}
                                </div>
                                <div className="photo-credit-container__content-brand-tagline-second-page content">
                                {props.photoCredit.gultigkeit_photocredit}
                                </div>
                            </div>
                        </div>
                        <div className="photo-credit-terms-modal--points">
                            <div className="icn">
                                <img src={IconInfo} alt="Info" className="photo-credit-icons" />
                            </div>
                            <div className="photo-credit-container__content-point-data">
                                <div className="photo-credit-container__content-point-title gultigkeit">
                                {t('Validity', props.lang)}
                                </div>
                                <div className="photo-credit-container__content-brand-tagline-second-page spacing">
                                    <ReactMarkdown {...MarkdownHelper.allTypes()}
                                        source={MarkdownHelper.parse(props.photoCredit.key_facts_photocredit || photoCreditDefaultState.key_facts_photocredit)}
                                        escapeHtml={false} />
                                </div>
                            </div>
                        </div>
                        <div className="photo-credit-terms-modal--points photo-credit-container__content-foto-label">
                            <div className="icn">
                                <img src={IconPhone} alt="Clock" className="photo-credit-icons" />
                            </div>
                            <div className="photo-credit-container__content-foto">
                            {t('Photo of verification', props.lang)}
                            </div>
                        </div>
                    </div>
                    <div className="photo-credit-overlay--process-title"> {t('How the photo-credit works: ', props.lang)}</div>
                    <div className="photo-credit-overlay--process">
                        <ReactMarkdown {...MarkdownHelper.allTypes()}
                            source={MarkdownHelper.parse(props.photoCredit.prozess_photocredit || photoCreditDefaultState.prozess_photocredit)}
                            escapeHtml={false} />
                    </div>
                    <div className="photo-credit-overlay--action-title">{t('Terms of action', props.lang)}</div>
                    <div className="photo-credit-overlay--action">
                        <ReactMarkdown {...MarkdownHelper.allTypes()}
                            source={MarkdownHelper.parse(props.photoCredit.tc || photoCreditDefaultState.tc)}
                            escapeHtml={false} />
                    </div>
                </div>
                <div className="photo-credit-terms-modal--footer">
                    <Button className="photo-credit-terms-modal--button">
                        OK
                    </Button>
                </div>
            </div>
        </div>
    </div>
)


const photoCreditDefaultState = {
    aktionszeitraum_photocredit: "",
    gultigkeit_photocredit: "",
    key_facts_photocredit: "",
    prozess_photocredit: "",
    tc: ""
}

export default PhotoCreditOverlay;


// WEBPACK FOOTER //
// ./src/components/ads/app/PhotoCreditOverlay.js